import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    name: '',
    authenticated: false,
  },
  userDetail: {},
  menuList: [],
  menuItemList: [],
  isLoading: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    login: (state, { payload }) => {
      state.data.name = payload.name;
      state.data.authenticated = payload.authenticated;
    },
    userDetail: (state, { payload }) => {
      state.userDetail = payload.userDetail;
    },
    menuList: (state, { payload }) => {
      state.menuList = payload.menuList;
    },
    isLoading: (state, { payload }) => {
      state.isLoading = payload.isLoading;
    },
    menuItemList: (state, { payload }) => {
      state.menuItemList = payload.menuItemList;
    },
  },
});

export const { login, userDetail, menuList, isLoading, menuItemList } =
  userSlice.actions;

export const selectUser = ({ user }) => user;

export const selectUserDetail = ({ user }) => user.userDetail;

export const selectMenuList = ({ user }) => user.menuList;

export const selectMenuItemList = ({ user }) => user.menuItemList;

export const selectIsLoading = ({ user }) => user.isLoading;

export default userSlice.reducer;